<template>
  <section id="MovieItem">
    <!-- START::__CAROUSEL___ -->

    <div class="upcoming">
      <template>
        <carousel-3d
          :listData="toprated"
          :disabled="true"
          :height="400"
          :width="300"
          :disable3d="false"
          :display="7"
          :space="250"
          :controls-visible="!$vuetify.breakpoint.xsOnly?true:false"
          :key="toprated.length"
          :clickable="true"
        >
          <slide
            :index="i"
            :key="i"
            v-for="(movie, i) in this.toprated"
            v-show="movie.poster_path != null"
          >
            <figure v-if="movie.poster_path != null">
              <!-- <figcaption>image</figcaption> -->
              <v-hover v-slot="{ hover }" open-delay="50">
                <v-card
                  class="mx-auto hidden-sm-and-down"
                  v-if="
                    movie.poster_path != null || movie.poster_path != undefined
                  "
                  style="cursor: pointer"
                  max-height="250"
                >
                  <v-img
                    max-width="300"
                    max-height="400"
                    min-width="300"
                    min-height="400"
                    position="center"
                    :src="`https://image.tmdb.org/t/p/w500${movie.poster_path}`"
                  >
                    <template #placeholder>
                      <v-card color="#111722" class="fill-height">
                        <v-skeleton-loader type="image, image" v-bind="attrs" />
                      </v-card>
                    </template>
                    <div
                      class="d-flex flex-column justify-space-between"
                      style="height: 100%"
                    >
                      <v-card-text
                        class="py-2 px-1 d-flex justify-space-between"
                      >
                        <h4
                          class="caption rating_box white--text font-weight-light px-4 py-0"
                        >
                          CAM
                        </h4>
                        <div
                          class="rating rating_box white--text font-weight-light px-2 py-0"
                        >
                          <v-icon left small color="#ffab31">mdi-star</v-icon>
                          <span class="caption">{{
                            Number(movie.vote_average).toFixed(1)
                          }}</span>
                        </div>
                      </v-card-text>
                      <!-- START::HOVER -->

                      <v-slide-y-reverse-transition>
                        <v-card v-if="hover" class="background transparent">
                          <v-card-text class="text-center">
                            <v-btn
                              small
                              @click="
                                saveToLocal(movie);
                                redirectTo(movie.id);
                              "
                              color="#ffab31"
                              dark
                              style="cursor: pointer"
                            >
                              <v-icon>mdi-play-outline</v-icon>
                              <span class="text-capitalize d-block">watch</span>
                            </v-btn>
                          </v-card-text>
                          <v-divider
                            class="pb-1 pt-3 divider_animation"
                            style="border-color: rgb(255 255 255 / 25%)"
                          ></v-divider>
                          <v-card-subtitle
                            style="cursor: pointer"
                            class="caption white--text text-center pt-0"
                            >{{ movie.title }}</v-card-subtitle
                          >
                          <v-card-text
                            class="d-flex align-center justify-center px-2"
                          >
                            <div
                              class="parent_chip"
                              style="display: flex; gap: 2px; flex-wrap: wrap"
                            >
                              <div
                                v-for="(mov, ind) in movie.genre_ids"
                                :key="ind"
                              >
                                <v-chip
                                  small
                                  v-show="item.id == mov && ind < 2"
                                  v-for="(item, i) in chips"
                                  :color="
                                    item.id == 28
                                      ? 'error'
                                      : item.id == 35
                                      ? 'yellow'
                                      : item.id == 16
                                      ? 'indigo'
                                      : ''
                                  "
                                  :key="i"
                                  :class="[
                                    { 'white--text': item.id == 16 },
                                    i == 0 ? 'hidden-sm-and-down' : '',
                                  ]"
                                >
                                  {{ item.name }}
                                </v-chip>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-slide-y-reverse-transition>
                      <!-- END::HOVER -->
                    </div>
                  </v-img>
                </v-card>
              </v-hover>
              <!-- <v-hover v-slot="{ hover }" open-delay="50"> -->
              <v-card
                class="mx-auto hidden-md-and-up"
                style="cursor: pointer"
                v-if="movie.poster_path != null"
                max-height="250"
              >
                <v-img
                  max-width="300"
                  max-height="400"
                  position="center"
                  :src="`https://image.tmdb.org/t/p/w500${movie.poster_path}`"
                >
                  <div
                    class="d-flex flex-column justify-space-between"
                    style="height: 100%"
                  >
                    <v-card-text class="py-2 px-1 d-flex justify-space-between">
                      <h4
                        class="caption rating_box white--text font-weight-light px-4 py-0"
                      >
                        CAM
                      </h4>
                      <div
                        class="rating rating_box white--text font-weight-light px-2 py-0"
                      >
                        <v-icon left small color="#ffab31">mdi-star</v-icon>
                        <span class="caption">{{
                          Number(movie.vote_average).toFixed(1)
                        }}</span>
                      </div>
                    </v-card-text>
                    <!-- START::HOVER -->

                    <v-slide-y-reverse-transition>
                      <v-card class="background transparent">
                        <v-card-text class="text-center">
                          <v-btn
                            small
                            @click="
                              saveToLocal(movie);
                              redirectTo(movie.id);
                            "
                            color="#ffab31"
                            dark
                            style="cursor: pointer"
                          >
                            <v-icon>mdi-play-outline</v-icon>
                            <span class="text-capitalize d-block">watch</span>
                          </v-btn>
                        </v-card-text>
                        <v-divider
                          class="pb-1 pt-3 divider_animation"
                          style="border-color: rgb(255 255 255 / 25%)"
                        ></v-divider>
                        <v-card-subtitle
                          :to="{
                            name: 'movieproduct',
                            params: { item: movie.id },
                          }"
                          @click="saveToLocal(movie)"
                          style="cursor: pointer"
                          class="caption white--text text-center pt-0"
                          >{{ movie.title }}</v-card-subtitle
                        >
                        <v-card-text
                          class="d-flex align-center justify-center px-2"
                        >
                          <div
                            class="parent_chip"
                            style="display: flex; gap: 2px; flex-wrap: wrap"
                          >
                            <div
                              v-for="(mov, ind) in movie.genre_ids"
                              :key="ind"
                            >
                              <v-chip
                                small
                                v-show="item.id == mov && ind < 2"
                                v-for="(item, i) in chips"
                                :color="
                                  item.id == 28
                                    ? 'error'
                                    : item.id == 35
                                    ? 'yellow'
                                    : item.id == 16
                                    ? 'indigo'
                                    : ''
                                "
                                :key="i"
                                :class="[
                                  { 'white--text': item.id == 16 },
                                  i == 0 ? 'hidden-sm-and-down' : '',
                                ]"
                              >
                                {{ item.name }}
                              </v-chip>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-slide-y-reverse-transition>
                    <!-- END::HOVER -->
                  </div>
                </v-img>
              </v-card>
              <!-- </v-hover> -->
            </figure>
          </slide>
        </carousel-3d>
      </template>
    </div>
    <!-- END::____CAROUSEL___ -->
  </section>
</template>

<script>
/** */
import { Carousel3d, Slide } from "vue-carousel-3d";
/** */
export default {
  props: {
    toprated:{
      default:''
    },
    showArrows:Boolean
  },
  name: "WrapAround",
  data: () => ({
    loading: true,
    plus: 5,
    attrs: {
      elevatin: 2,
      class: "mb-6",
      boilerplate: false,
    },
    chips: [],
    colors: ["primary", "secondary", "yellow darken-2", "red", "orange"],
    //data list [array]
    carousel: 4,
    someList: [
      {
        html: "slider1",
        style: {
          background: "#4abf8a",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider2",
        style: {
          background: "#4bbfc3",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider3",
        style: {
          background: "#7baabe",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider4",
        style: {
          background: "#7caabe",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider5",
        style: {
          background: "#4abf8a",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider6",
        style: {
          background: "#4bbfc3",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider7",
        style: {
          background: "#7baabe",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
      {
        html: "slider8",
        style: {
          background: "#7caabe",
          width: "23.5%",
          "margin-right": "2%",
        },
      },
    ],
    //Slider configuration [obj]
    options: {
      currentPage: 0,
      tracking: false,
      thresholdDistance: 100,
      thresholdTime: 300,
      infinite: 4,
      slidesToScroll: 4,
      loop: true,
    },
    firstLoad: true,
    cards: [1, 2, 3, 4, 5, 6, 7, 8],
    innerStyles: {},
    step: "",
    transitioning: false,
    // item
    movies: [],
  }),
  components: {
    Carousel3d,
    Slide,
  },
  mounted() {
    // console.log("from child ", this.toprated);
    this.getGenres();
  },
  methods: {
    redirectTo(movieId) {
      this.$router
        .push({ name: "movieproduct", params: { item: movieId } })
        .then(() => {
          this.$vuetify.goTo(0, {
            duration: 750,
          });
        })
        .catch((err) => err);
    },
    saveToLocal(item) {
      localStorage.setItem("currentItem", JSON.stringify(item));
    },
    async getGenres() {
      await this.$axios
        .get(
          `https://api.themoviedb.org/3/genre/movie/list?api_key=${this.$apiKey}&language=en-US`
        )
        .then((resp) => {
          this.chips = resp.data.genres;
          // console.log(resp.data.genres);
        });
    },
  },
  created() {
    const readyHandler = () => {
      if (document.readyState == "complete") {
        setTimeout(() => {
          this.firstLoad = false;
        }, 1500);
        document.removeEventListener("readystatechange", readyHandler);
      }
    };
    document.addEventListener("readystatechange", readyHandler);
    readyHandler();

    /** */
    // console.log(
    //   this.carousel == 0 ? 0 : this.carousel * this.plus,
    //   this.carousel == 0 ? this.plus : this.carousel * this.plus + this.plus
    // );
    /** */
  },
};
</script>

<style lang="scss" scoped>
#MovieItem {
  // background-color: #111722;
}
.carousel {
  width: 80%;
  overflow: hidden;
}
.inner {
  transition: transform 0.2s;
  white-space: nowrap;
}
.carousel {
  .inner {
    .carousel_card {
      width: 40px;
      margin-right: 10px;
      display: inline-flex;
      /* optional */
      height: 40px;
      background-color: #39b1bd;
      color: white;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
    }
  }
}
/* optional */
button {
  margin-right: 5px;
  margin-top: 10px;
}
#Movie {
  // background: #3d4b5e;
  background: #111722;
  // background-image: url("../../assets/movie/Iron-Man-Wallpapers.jpg");
  // width: 60%;
  //http://www.omdbapi.com/?i=tt3896198&apikey=464a6908
}
.card-body {
  background: rgba($color: #000000, $alpha: 0.3);
}
@import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,500&display=swap");
.main_color {
  color: #111722;
}
.main_back {
  background: #111722;
}
* {
  font-family: "Rubik", sans-serif;
}
.rating_box {
  background: #28282c;
  border-radius: 4px;
}
.background {
  background: linear-gradient(to top, transparent, rgb(85 85 85 / 85%));
}
.divider_animation {
  animation: divider 1s forwards;
  margin-left: auto;
}
@keyframes divider {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
.visible_card {
  visibility: hidden !important;
}
.next {
  span {
    color: rgb(163 169 177) !important;
  }
}
</style>
